<div
    [style.background]="chipBgColor()"
    [style.cursor]="pointer() ? 'pointer' : ''"
    [class]="isActive() ? 'is-active' : ''">
    {{ chip() }}
</div>
